//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../views/common-components/file-uploader';
import { formatDate } from '../../lib/date';
import ProjectOnSale from './project-onSale';
import PageDutyView from './components/page-duty-view';
import PageBuildingRepairer from './components/page-building-repairer';
import ProjectPhoneView from './components/project-phone-view';
import ProjectPrintView from './components/project-print-view';
import ProjectHouseTypeView from './components/project-houseType-view';

export default {
    name: 'projectDetail',
    components: {
        ProjectHouseTypeView,
        ProjectPrintView,
        ProjectPhoneView,
        PageBuildingRepairer,
        PageDutyView,
        ProjectOnSale,
        fileUploader
    },
    filters: {
        formatDate(time, type) {
            const date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            projectId: 0,
            loading: false,
            project: {
                id: 0,
                name: ''
            },
            name: 'name1'
        };
    },
    methods: {
        getProject() {
            this.loading = true;
            this.$store.dispatch({
                type: 'project/GetProjectById',
                id: this.projectId
            }).then(() => {
                this.project = this.$store.state.project.projectInfo;
            }).finally(() => {
                this.loading = false;
            });
        },

        tabClicked(val) {
            this.name = val;
        }
    },
    created() {
        this.projectId = parseInt(this.$route.params.id) || 0;
        if (this.projectId > 0) {
            this.getProject();

        }
    }
};
